import Footer from '../components/layout/Footer';
import ConsultationTaskList from '../components/consultation/ConsultationTaskList';

export default function Consulting() {
  return (
    <main className="h-full flex-1 overflow-y-auto overscroll-contain">
      <div className="min-h-full flex flex-col">
        <div className="grow">
          <ConsultationTaskList />
        </div>
        <Footer />
      </div>
    </main>
  );
}
